import { render, staticRenderFns } from "./CompareButton.vue?vue&type=template&id=a823dde6"
import script from "./CompareButton.vue?vue&type=script&lang=js"
export * from "./CompareButton.vue?vue&type=script&lang=js"
import style0 from "./CompareButton.vue?vue&type=style&index=0&id=a823dde6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports